import React from 'react'
import { connect } from 'react-redux'
import { Link, Routes, Route } from 'react-router-dom'

import { handleSignOut } from '../../actions/auth'
import { routes, nestedRoutePath } from '../../constants/routes'

import AgentsIndex from './agents/index'
import BookingsIndex from './bookings/index'
import FinanceIndex from './finances/index'

class AdminIndex extends React.Component {
    state = {}

    render = () => {
        return (
            <>
                <div className="main-nav admin">
                    <div className="logo-title">
                        <span>Luna Moons Lead Platform</span>
                    </div>
                    <div className="links">
                        <div className="sections">
                            <Link to={routes.appIndex}>App</Link>
                            <Link to={routes.adminAgentsIndex}>Agents</Link>
                            <Link to={routes.adminBookingsIndex}>Bookings</Link>
                            <Link to={routes.adminFinanceIndex}>Financials</Link>
                        </div>
                        <div className="account">
                            <span onClick={() => this.props.dispatch(handleSignOut())}>Sign Out</span>
                        </div>
                    </div>
                </div>
                <div id="route-content">
                    <Routes>
                        <Route path={nestedRoutePath(routes.adminIndex, routes.adminAgentsIndex, true)} element={<AgentsIndex />} />
                        <Route path={nestedRoutePath(routes.adminIndex, routes.adminBookingsIndex, true)} element={<BookingsIndex />} />
                        <Route path={nestedRoutePath(routes.adminIndex, routes.adminFinanceIndex, true)} element={<FinanceIndex />} />
                        <Route path="*" element={<div>I am something</div>} />
                    </Routes>
                </div>
            </>
        )
    }
}

export default connect()(AdminIndex)
